import React from 'react';
import PropTypes from 'prop-types';
import css from './NotificationMessage.scss';
import MaterialIcon from '../SF/MaterialIcon';

export default class NotificationMessage extends React.Component {

  constructor(props) {
    super(props);

    this.state = { visibility: props.display };
  }

  handleClose = () => {
    this.setState({ visibility: false });
  };

  render() {

    let visibilityCls = this.state.visibility ? css['visible'] : css['hideme'];

    return (
        <div className={visibilityCls}>
          <div className={css['message-container']}>
            <div className={css['info-icon']} ><MaterialIcon aria-hidden="true" icon="info" /></div>
            <div className={css['message-text']} data-role="alertFilterMessage">{this.props.message}</div>
          </div>
          <div aria-label="Dismiss"
               className={css['close-icon']}
               onClick={this.props.onClose ? this.props.onClose : this.handleClose}
               role="button"
               tabIndex="0">
            <MaterialIcon icon="close" />
          </div>
        </div>
    );
  }
}

NotificationMessage.propTypes = {
  message: PropTypes.string.isRequired,
  display: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
};
